import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppFlyoutAnchor } from 'owa-command-ribbon';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import type { IButtonStyles } from '@fluentui/react';
import { FormatControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';

import {
    tableControlMenuDelete,
    tableControlMenuMerge,
    tableControlMenuSplit,
    tableControlMenuInsert,
    tableControlMenuAlignCellHorizontally,
    tableControlMenuAlignCellVertically,
} from './tableControlsStrings.locstring.json';
import { getMenuDefinitionForControls } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu/getMenuDefinitionForControls';
import { getTableOperationControl } from './getTableOperationControl';
import { AppControlProps } from '@1js/acui-ribbon-like';

export const getTableOperationMenu = computedFn(
    (
        viewState: EditorViewState,
        controlId:
            | FormatControlId.DeleteTableMenu
            | FormatControlId.TableInsertMenu
            | FormatControlId.TableMergeCellsMenu
            | FormatControlId.TableSplitCellsMenu
            | FormatControlId.TableAlignCellHorizontallyMenu
            | FormatControlId.TableAlignCellVerticallyMenu,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        let controls: FormatControlId[] = [];
        let label: string = '';
        switch (controlId) {
            case FormatControlId.DeleteTableMenu:
                label = tableControlMenuDelete;
                controls = [
                    FormatControlId.DeleteTable,
                    FormatControlId.DeleteRows,
                    FormatControlId.DeleteColumns,
                ];
                break;
            case FormatControlId.TableInsertMenu:
                label = tableControlMenuInsert;
                controls = [
                    FormatControlId.InsertRowAbove,
                    FormatControlId.InsertRowBelow,
                    FormatControlId.InsertColumnLeft,
                    FormatControlId.InsertColumnRight,
                ];
                break;
            case FormatControlId.TableMergeCellsMenu:
                label = tableControlMenuMerge;
                controls = [
                    FormatControlId.MergeAbove,
                    FormatControlId.MergeBelow,
                    FormatControlId.MergeLeft,
                    FormatControlId.MergeRight,
                ];
                break;
            case FormatControlId.TableSplitCellsMenu:
                label = tableControlMenuSplit;
                controls = [
                    FormatControlId.SplitCellsHorizontally,
                    FormatControlId.SplitCellsVertically,
                ];
                break;
            case FormatControlId.TableAlignCellVerticallyMenu:
                label = tableControlMenuAlignCellVertically;
                controls = [
                    FormatControlId.AlignTableCellTop,
                    FormatControlId.AlignTableCellMiddle,
                    FormatControlId.AlignTableCellBottom,
                ];
                break;
            case FormatControlId.TableAlignCellHorizontallyMenu:
                label = tableControlMenuAlignCellHorizontally;
                controls = [
                    FormatControlId.AlignTableCellLeft,
                    FormatControlId.AlignTableCellCenter,
                    FormatControlId.AlignTableCellRight,
                ];
                break;
        }
        return createAppFlyoutAnchor(
            getComposeRibbonId(controlId, viewState),
            loc(label),
            getMenuDefinitionForControls([
                ...controls.map(op => {
                    return getTableOperationControl(viewState, op, styles) as AppControlProps;
                }),
            ]),
            undefined /* keytipProps */,
            undefined /* icon */,
            undefined /* iconColor */,
            styles
        );
    }
);
